<template>

<div class="address text-block">

	<div class="address-icon"></div>
	<h3 class="address-text"><a :href="item.url || false" target="_blank" rel="noopener">{{ item.content }}</a></h3>

</div>

</template>

<script>

export default {

	props: ['item']

}

</script>

<style scoped>

.address {
	display: flex;
	flex-direction: row;
}

.address-icon {
	width: 20px;
	height: 20px;
	margin-right: 10px;
	flex-shrink: 0;
	background-size: 17px 17px;
	background-position: 50% 50%;
	background-repeat: no-repeat;
	background-image: url(~@/assets/text/address.svg);
}

.address-text {
	color: #707070;
	font-size: 18px;
	flex-grow: 1;
	line-height: 24px;
	margin-bottom: 5px;
}

</style>
